import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AbcIcon from "@mui/icons-material/Abc";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

export const BlocksUserSigninPage = (props) => {
  const [open, setOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState(true);
  const [menu, setMenu] = useState(false);
  return (
    <div className="get-started-page">
      <header className="topbar">
        <IconButton
          className="menu-button"
          onClick={() => {
            setMenu(true);
          }}
        >
          <MenuIcon />
        </IconButton>
        <div className="topbar-logo">
          <a href="https://www.fabloq.com">
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="block"></div>
            </div>
          </a>
        </div>
        <span className="topbar-docs">Docs</span>
      </header>

      <main className="content">
        <Drawer
          open={menu}
          onClose={() => {
            setMenu(false);
          }}
          className="drawer"
        >
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </Drawer>
        <div className="sidebar" style={{ height: window.innerHeight - 55 }}>
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </div>
        <div className="article">
          <div className="article-left" />
          <div className="article-content">
            <h2 className="topic-title" id="user-signin-block">
              <span className="hashtag">#</span> User Sign In Block
            </h2>
            <p className="topic-para">
              User Sign in block is used to create API endpoint for user sign
              in.
            </p>
            <div className="topic-para-note">
              <p className="topic-para">
                <span className="topic-para-bold">NOTE:</span> Sign-in must be
                used with POST method.
              </p>
            </div>
            <h2 className="topic-title" id="how-to-create-user-signin-block">
              <span className="hashtag">#</span> How to create a User Sign In
              Block
            </h2>
            <p className="topic-para">
              Select “User Sign In” under “Authentication” in Add a block
              dialog.
            </p>
            <h2 className="topic-title" id="how-to-use-user-signin-block">
              <span className="hashtag">#</span> How to use a User Sign In Block
            </h2>
            <p className="topic-para">
              Once your API endpoint is created. Go to your frontend app and
              send following fields: username and password where username can be
              username or email of the user in database. If you don't add any of
              the following fields endpoint will throw error.
            </p>
            <div className="topic-code">
              <p className="topic-para">
                {"{"}
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;“username”: “test.username”,
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;“password”: “examplepassword”, <br></br>
                {"}"}
              </p>
            </div>
            <p className="topic-para">
              On successful login you will get following response:
            </p>
            <div className="topic-code">
              <p className="topic-para">
                {"{"}
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;"status": "error",
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;"token": "example_token"
                <br></br>
                {"}"}
              </p>
            </div>
            <h2 className="topic-title" id="errors">
              <span className="hashtag">#</span> Errors
            </h2>
            <p className="topic-para">
              Errors will be sent in JSON form and will have following fields:
              status, type, message
            </p>
            <h3 className="topic-subtitle" id="username-key-missing">
              <span className="hashtag">#</span> Username key missing
            </h3>
            <div className="topic-code">
              <p className="topic-para">
                {"{"}
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;"status": "error",
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;"type": "username key missing"<br></br>
                {"}"}
              </p>
            </div>
            <p className="topic-para">
              Following error will occur if username key is missing in request
              data.
            </p>
            <h3 className="topic-subtitle" id="password-key-missing">
              <span className="hashtag">#</span> Password key missing
            </h3>
            <div className="topic-code">
              <p className="topic-para">
                {"{"}
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;"status": "error",
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;"type": "password key missing"
                <br></br>
                {"}"}
              </p>
            </div>
            <p className="topic-para">
              Following error will occur if password key is missing in request
              data.
            </p>
            <h3 className="topic-subtitle" id="user-not-found">
              <span className="hashtag">#</span> User not found
            </h3>
            <div className="topic-code">
              <p className="topic-para">
                {"{"}
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;"status": "error",
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;"type": "user not found"
                <br></br>
                {"}"}
              </p>
            </div>
            <p className="topic-para">
              Following error will occur if user with given username or email
              does not exists in database.
            </p>
            <h3 className="topic-subtitle" id="unauthorised-access">
              <span className="hashtag">#</span> Unauthorised access
            </h3>
            <div className="topic-code">
              <p className="topic-para">
                {"{"}
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;"status": "error",
                <br></br>
                &nbsp;&nbsp;&nbsp;&nbsp;"type": "password field is empty"
                <br></br>
                {"}"}
              </p>
            </div>
            <p className="topic-para">
              Following error will occur if password for given user is wrong.
            </p>
            <div className="topic-footline"></div>
            <div className="topic-buttons">
              <Button component={RouterLink} to="/blocks/usersignup">
                <ChevronLeftIcon /> User Signup
              </Button>
              <div />
            </div>
          </div>
          <div className="article-right" />
        </div>
        <div className="index">
          <a className="index-title">Contents</a>
          <a className="index-topic" href="#user-signin-block">
            User Sign In Block
          </a>
          <a className="index-topic" href="#how-to-create-user-signin-block">
            How to create a User Sign In Block
          </a>
          <a className="index-topic" href="#how-to-use-user-signin-block">
            How to use a User Sign In Block
          </a>
          <a className="index-topic" href="#errors">
            Errors
          </a>
          <div className="index-sublist">
            <a href="#username-key-missing" className="index-subtopic">
              Username key missing
            </a>
            <a href="#password-key-missing" className="index-subtopic">
              Password key missing
            </a>
            <a href="#user-not-found" className="index-subtopic">
              User not found
            </a>
            <a href="#unauthorised-access" className="index-subtopic">
              Unauthorised access
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};
